import { $, $$ } from 'utils/dom';

const textimages = $$('.landingpage-textimage');

// IntersectionObserver to detect when textimage is in viewport
if (textimages.length) {
  textimages.forEach(textimage => {
    const observerAbove = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // if in viewport, add class is-animated to picture-below and picture-above
            const picturesAbove = $$(
              '.landingpage-textimage__picture-above',
              entry.target
            );
            picturesAbove.forEach(picture => {
              picture.classList.add('is-animated');
            });
          }
        });
      },
      {
        rootMargin: '0px 0px',
        threshold: 0.5,
      }
    );
    observerAbove.observe(textimage);

    const textimagesContext = $('.landingpage-textimage__context', textimage);
    const observerBelow = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // if in viewport, add class is-animated to picture-below and picture-above
            const picturesBelow = $$(
              '.landingpage-textimage__picture-below',
              entry.target.parentElement
            );
            picturesBelow.forEach(picture => {
              picture.classList.add('is-animated');
            });
          }
        });
      },
      {
        rootMargin: '0px 0px',
        threshold: 0.9,
      }
    );
    observerBelow.observe(textimagesContext);
  });
}
